<template>
  <ValidationObserver ref="interviewFormatForm">
    <div class="mt-4">
      <ValidationProvider v-slot="{ errors }" name="name" rules="required">
        <v-text-field
          :error-messages="getErrorMessages(errors)"
          label="Name"
          class="mb-4 mt-2"
          v-model="interviewFormatTemplateData.interviewName"
        />
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        name="duration"
        rules="required|minNumber:0"
      >
        <v-text-field
          :error-messages="getErrorMessages(errors)"
          label="Duration (minutes)"
          class="mb-4 mt-2"
          type="number"
          v-model="interviewFormatTemplateData.duration"
        />
      </ValidationProvider>
      <v-label>Candidate Description</v-label>
      <quill-editor
        v-model="interviewFormatTemplateData.candidateDetails"
        :options="editorOptions"
        class="mb-4 mt-2"
      />
      <v-label>Interviewer Description</v-label>
      <quill-editor
        v-model="interviewFormatTemplateData.interviewerDetails"
        :options="editorOptions"
        class="mb-4 mt-2"
      />
      <ValidationProvider v-slot="{ errors }" rules="required">
        <Select
          v-model="interviewFormatTemplateData.tags"
          :items="tags"
          :loading="isFetchingTags"
          label="Tags"
          multiple
          :error-messages="getErrorMessages(errors)"
        />
      </ValidationProvider>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { merge } from "lodash";
import { DEFAULT_TOOLBAR_OPTIONS } from "@/plugins/v-quill-editor";
import { mapState } from "vuex";
import Select from "@/components/common/Select";
import { createNamespacedHelpers } from "vuex";
import { DATA_NAMESPACE } from "@/store/modules/data";
import { FETCH_TAGS } from "@/store/modules/data/actions";
import { GET_TAGS, GET_IS_FETCHING_TAGS } from "@/store/modules/data/getters";

const {
  mapActions: mapDataActions,
  mapGetters: mapDataGetters
} = createNamespacedHelpers(DATA_NAMESPACE);

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Select
  },
  props: {
    interviewFormatTemplate: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      interviewFormatTemplateData: {
        interviewName: "",
        duration: 0,
        candidateDetails: "",
        interviewerDetails: "",
        tags: []
      },
      showValidationErrors: false,
      editorOptions: {
        modules: {
          toolbar: {
            container: DEFAULT_TOOLBAR_OPTIONS
          }
        }
      }
    };
  },
  created() {
    this.fetchTags({
      filter: {
        taxonomy: "interview_format_templates"
      }
    });
    if (this.interviewFormatTemplate) {
      this.adjustinterviewFormatTemplateData();
    }
  },
  computed: {
    ...mapDataGetters({
      tags: GET_TAGS,
      isFetchingTags: GET_IS_FETCHING_TAGS
    }),
    ...mapState("auth", {
      user: state => state.userData
    }),
    userOrganisationId() {
      return this.user.organisation && this.user.organisation.id;
    }
  },
  methods: {
    ...mapDataActions({
      fetchTags: FETCH_TAGS
    }),
    adjustinterviewFormatTemplateData() {
      this.interviewFormatTemplateData = merge(
        {},
        this.interviewFormatTemplate
      );
    },
    close() {
      this.$emit("close");
    },
    async validateForm() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.interviewFormatForm.validate();
      if (isValid) {
        this.$emit("onSubmit", this.interviewFormatTemplateData);
      }
      return isValid;
    },
    getErrorMessages(errors) {
      return this.showValidationErrors ? errors : "";
    }
  }
};
</script>

<style lang="scss"></style>
